import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'issueBillingCharges',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: {
        invoices: [],
        total: 0,
        hasCustomChargeDate: false,
        customChargeDate: null
      },
      lang: '',
      customChargeDateView: null,
      
      invoicesCols: [],
      keyColumn: 'effectiveDate'
    }
  },
  watch: {
    customChargeDateView: function (val) {
      this.appData.customChargeDate = moment(val, "DD/MM/YYYY");
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('issue_billing_charges_updated', this.init);
    this.fillInvoicesCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;

        if (this.appData.hasCustomChargeDate)
          this.customChargeDateView = moment(this.appData.customChargeDate).format('DD/MM/YYYY');
      });
    },
    getData() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/IssueBillingChargesActivity/GetData', parameter),
        response => {
          if (response.status == 200) {
            if (moment(response.data.item.customChargeDate).year() < 1990)
              response.data.item.customChargeDate = moment().format();

            this.invoices = response.data.invoices;
            this.hasCustomChargeDate = response.data.hasCustomChargeDate;
            this.total = response.data.total;
            this.customChargeDate = response.data.customChargeDate;
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //axios.post('/IssueBillingChargesActivity/GetData', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.invoices = response.data.invoices;
      //      this.hasCustomChargeDate = response.data.hasCustomChargeDate;
      //      this.total = response.data.total;
      //      this.customChargeDate = response.data.customChargeDate;
      //    }
      //  })
      //  .catch(error => {
      //    this.$alertMsg(error.response.data);
      //  });
    },
    fillInvoicesCols() {
      this.invoicesCols.push({ dataField: 'effectiveDate', caption: this.$t('activities.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.invoicesCols.push({ dataField: 'transactionDescription', caption: this.$t('activities.type') });
      this.invoicesCols.push({ dataField: 'chargeDescription', caption: this.$t('activities.description') });
      this.invoicesCols.push({ dataField: 'meter', caption: this.$t('activities.meter') });
      this.invoicesCols.push({ dataField: 'amount', caption: this.$t('activities.grossAmount') });
      this.invoicesCols.push({ dataField: 'netAmount', caption: this.$t('activities.netAmount') });
      this.invoicesCols.push({ dataField: 'vatAmount', caption: this.$t('activities.vatAmount') });
      this.invoicesCols.push({ dataField: 'ReadingFromDate', caption: this.$t('activities.fromDate'), formatData: this.$options.filters.formatDateDDMMYYY });
      this.invoicesCols.push({ dataField: 'prevReading', caption: this.$t('activities.fromReading') });
      this.invoicesCols.push({ dataField: 'readingToDate', caption: this.$t('activities.toDate'), formatData: this.$options.filters.formatDateDDMMYYY });
      this.invoicesCols.push({ dataField: 'curReading', caption: this.$t('activities.toReading') });
      this.invoicesCols.push({ dataField: 'consumption', caption: this.$t('activities.consumption') });
    },
    setCustomDate() {
      if (!this.appData.customChargeDate)
        return;

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        CustomChargeDate: moment(this.appData.customChargeDate).format()
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/IssueBillingChargesActivity/SetCustomDate', parameter),
        response => {
          if (response.status == 200)
            this.$alertMsg(this.$t('messages.IssueBillingChargesSuccess'), 2);
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //axios.post('/IssueBillingChargesActivity/SetCustomDate', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$alertMsg(this.$t('messages.IssueBillingChargesSuccess'), 0);
      //    }
      //  })
      //  .catch(error => {
      //    this.$alertMsg(error.response.data);
      //  });
    }
  },
}
